module.exports = __webpack_public_path__ + "static/media/ljubljana-25.c29b6d07.jpg";